import React from "react";
import { contractorConfig } from "../data/contractorConfig";

const ContractorTemplate = () => {
  const { company, invoice, terms, currency } = contractorConfig;
  const headerYellow = "bg-[#F1E48E]";

  return (
    <div
      id="contractor-invoice"
      className="bg-white px-12 py-8 text-gray-800 font-sans mx-auto max-w-5xl"
    >
      <div className="flex justify-between items-start mb-10">
        <div className="flex items-center gap-4">
          {company.logo && (
            <img
              src={company.logo}
              alt="Company Logo"
              className="w-28 h-20 object-contain"
            />
          )}
        </div>

        <div className="text-right leading-relaxed">
          <h2 className="font-bold text-lg">{company.name}</h2>
          <p className="text-sm text-gray-500">
            {company.address.map((line, i) => (
              <span key={i}>
                {line}
                <br />
              </span>
            ))}
          </p>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-8 mb-10">
        <div>
          <p className="text-gray-500 font-medium text-sm mb-1">Bill To</p>
          <p className="font-bold text-base">{invoice.clientName}</p>
          <p className="text-sm text-gray-500 max-w-[240px] leading-relaxed">
            {invoice.clientAddress}
          </p>
        </div>

        <div className="flex flex-col items-end">
          <h1 className="text-2xl font-light text-gray-400 mb-4 tracking-widest uppercase">
            Invoice
          </h1>
          <div className="grid grid-cols-2 gap-x-6 gap-y-2 text-sm w-full max-w-[260px]">
            <span className="font-semibold">Invoice #</span>
            <span className="text-right">{invoice.invoiceNumber}</span>

            <span className="font-semibold">Invoice Date</span>
            <span className="text-right">{invoice.invoiceDate}</span>

            <span className="font-semibold">Terms</span>
            <span className="text-right text-xs">{terms.payment}</span>

            <span className="font-semibold">Due Date</span>
            <span className="text-right">{invoice.dueDate}</span>
          </div>
        </div>
      </div>

      <table className="w-full border-collapse mb-10">
        <thead>
          <tr className={`${headerYellow} text-sm font-bold`}>
            <th className="py-2 px-3 border border-gray-200 text-center w-10">#</th>
            <th className="py-2 px-3 border border-gray-200 text-left">Item</th>
            <th className="py-2 px-3 border border-gray-200 text-left">Description</th>
            <th className="py-2 px-3 border border-gray-200 text-right">Qty</th>
            <th className="py-2 px-3 border border-gray-200 text-right">Rate</th>
            <th className="py-2 px-3 border border-gray-200 text-right">Amount</th>
          </tr>
        </thead>

        <tbody className="text-sm">
          {invoice.items.map((item, idx) => (
            <tr key={idx} className="border-b border-gray-100 align-top">
              <td className="py-4 px-3 text-center text-gray-400 border-x border-gray-100">
                {idx + 1}
              </td>
              <td className="py-4 px-3 border-x border-gray-100">{item.name}</td>
              <td className="py-4 px-3 text-xs text-gray-500 border-x border-gray-100 leading-relaxed">
                {item.desc}
              </td>
              <td className="py-4 px-3 text-right border-x border-gray-100">
                {item.qty}
                {item.unit && (
                  <div className="text-[10px] text-gray-400">{item.unit}</div>
                )}
              </td>
              <td className="py-4 px-3 text-right border-x border-gray-100">
                {item.rate}
              </td>
              <td className="py-4 px-3 text-right font-medium border-x border-gray-100">
                {item.amount}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="flex justify-between items-start mt-6">
        <p className="text-sm text-gray-500 italic pt-2">
          Thanks for your business.
        </p>

        <div className="w-80 text-sm space-y-2">
          <div className="flex justify-between">
            <span className="text-gray-500">Sub Total</span>
            <span>{currency}{invoice.subTotal}</span>
          </div>

          <div className="flex justify-between text-gray-500">
            <span>Discount</span>
            <span>(-){currency}{invoice.discount}</span>
          </div>

          <div className="flex justify-between text-gray-500">
            <span>Shipping Charge</span>
            <span>{currency}{invoice.shipping}</span>
          </div>

          <div className="flex justify-between text-gray-500">
            <span>Advance Paid</span>
            <span>(-){currency}{invoice.advancePaid}</span>
          </div>

          <div className="flex justify-between font-bold text-base pt-4 border-t">
            <span>Total</span>
            <span>{currency}{invoice.total}</span>
          </div>

          <div className="flex justify-between p-3 border-y border-gray-200 mt-4 text-lg font-bold">
            <span>Balance Due</span>
            <span>{currency}{invoice.total}</span>
          </div>
        </div>
      </div>

      <div className="mt-16 border-t pt-4">
        <p className="font-bold text-sm mb-2">Terms & Conditions</p>
        <p className="text-xs text-gray-500 leading-relaxed">
          {terms.footer}
        </p>
      </div>
    </div>
  );
};

export default ContractorTemplate;
